// Dashboards hub — the signed-in person's pinned dashboards
// (GET/PUT /v1/me/dashboard-pins). Errors go through jsonOrThrow, so a
// 400 shows the api's per-field issues rather than "Validation failed".

import { jsonOrThrow } from './apiError';

const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8080';

export async function getDashboardPins(idToken: string): Promise<string[]> {
  const res = await fetch(`${API_URL}/v1/me/dashboard-pins`, {
    headers: { authorization: `Bearer ${idToken}` },
  });
  const body = await jsonOrThrow<{ keys?: string[] }>(res);
  return body.keys ?? [];
}

export async function saveDashboardPins(idToken: string, keys: string[]): Promise<string[]> {
  const res = await fetch(`${API_URL}/v1/me/dashboard-pins`, {
    method: 'PUT',
    headers: {
      authorization: `Bearer ${idToken}`,
      'content-type': 'application/json',
    },
    body: JSON.stringify({ keys }),
  });
  const body = await jsonOrThrow<{ keys?: string[] }>(res);
  return body.keys ?? keys;
}
